<app-job-blogs></app-job-blogs>
<div class="jobs-filter-container">
    <!-- Find jobs by city -->
    <div class="filter-section">
        <h2>Find jobs by city</h2>
        <div class="filter-links">
            <a href="#">Ahmedabad</a>
            <a href="#">Jaipur</a>
            <a href="#">Gandhinagar</a>
            <a href="#">Kanpur</a>
            <a href="#">Bangalore</a>
            <a href="#">Lucknow</a>
            <a href="#">Pune</a>
            <a href="#">Noida</a>
            <a href="#">Delhi</a>
            <a href="#">Chennai</a>
            <a href="#">Udaipur</a>
            <a href="#">Gurgaon</a>
            <a href="#">NCE region</a>
        </div>
    </div>

    <!-- Find jobs by levels -->
    <div class="filter-section">
        <h2>Find jobs by levels</h2>
        <div class="filter-links">
            <a href="#">Pre-primary education</a>
            <a href="#">Primary education</a>
            <a href="#">Secondary education</a>
            <a href="#">Higher secondary education</a>
        </div>
    </div>

    <!-- Find jobs by board -->
    <div class="filter-section">
        <h2>Find jobs by board</h2>
        <div class="filter-links">
            <a href="#">CBSE</a>
            <a href="#">ISEB</a>
            <a href="#">GSEB</a>
            <a href="#">UPEB</a>
            <a href="#">MESB</a>
            <a href="#">PESB</a>
        </div>
    </div>
</div>

<div class="footer-top">
    <div class="footer-container">
        <div class="footer-content">
            <div class="footer-left">
                <div class="logo-section">
                    <img src="../assets/images/logo.svg" alt="Inforida Logo" class="logo" />
                    <p class="tagline">Simplifying <br>School<br>Performance</p>
                </div>
                <div class="social-icons">
                    <a href="#">
                        <img src="../assets/images/foot_linkdin.png" alt="LinkedIn" />
                    </a>
                    <a href="#"><img src="../assets/images/foot_wa.png" alt="WhatsApp" /></a>
                    <a href="#"><img src="../assets/images/foot_fb.png" alt="Facebook" /></a>
                    <a href="#"><img src="../assets/images/foot_insta.png" alt="Instagram" /></a>
                </div>
            </div>

            <div class="footer-menu">
                <div class="menu-column">
                    <h3>MENU</h3>
                    <a href="#">Home</a>
                    <a href="#">Platform</a>
                    <a href="#">Ecosystem</a>
                    <a href="#">About us</a>
                    <a href="#">Resources</a>
                    <a href="#">Contact us</a>
                </div>

                <div class="menu-column">
                    <h3>ECOSYSTEM</h3>
                    <a href="#">For Schools</a>
                    <a href="#">For Teachers</a>
                    <a href="#">For Parents</a>
                </div>

                <div class="menu-column">
                    <h3>OTHERS</h3>
                    <a href="#">Privacy policy</a>
                    <a href="#">Sales & refund</a>
                    <a href="#">Terms of use</a>
                    <a href="#">Legal</a>
                </div>
            </div>

            <div class="footer-right">
                <a href="#" class="sign-up-btn">Sign up Now</a>
                <div class="contact-info">
                    <p>+91-9876543210</p>
                    <!-- <a href="mailto:team@inforida.in">team@inforida.in</a> -->
                    <a href="mailto:team@inforida.in">{{emailId}}</a>
                </div>
                <a href="#"><img src="../assets/images/google-play-badge.png" alt="Get it on Google Play"
                        class="play-store" /></a>
            </div>
        </div>

        <div class="footer-bottom">
            <div class="office-info">
                <div class="head-office">
                    <p><strong>Head office</strong></p>
                    <p>Inforida Technologies</p>
                    <p>1153, HSR Layout, Banglore - 560102</p>
                </div>
                <div class="zonal-office">
                    <p><strong>Zonal office</strong></p>
                    <p>Inforida Technologies</p>
                    <p>F45, Skyline Plaza, Sushant Golf City, Shaheed Path, Lucknow - 226030</p>
                </div>
            </div>

        </div>
    </div>
    <p class="copyright">© 2024 Inforida Technologies - Copyright</p>
</div>